import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ServiceSubject} from '../Models/ServiceSubject';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ServiceSubjectService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getServiceSubjects(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-subject/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public list() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-subject/list')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getArchiveServiceSubjects(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-subject/archive/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceSubjectItem(id = null) {
    return this.http.get<ServiceSubject>(environment.apiUrl + '/backoffice/service-subject/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/service-subject/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public deleteServiceSubject(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/service-subject/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public readdServiceSubject(id) {
    return this.http.put(environment.apiUrl + '/backoffice/service-subject/' + id + '/readd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceSubject(serviceSubjectId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-subject/' + serviceSubjectId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageServiceSubject(serviceSubject, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/service-subject/' + id, serviceSubject)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/service-subject/ ', serviceSubject)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public saveProducts(serviceSubject, id = null) {
    return this.http.put(
      environment.apiUrl + '/backoffice/service-subject/' + id + '/products',
      serviceSubject
    ).pipe(catchError(res => this.helper.catchError(res)));
  }
}
